import React from 'react';
import Icon from '../../../AppIcon';

const DataQualityMetrics = ({ metrics }) => {
  const qualityIndicators = [
    {
      label: 'Completeness',
      value: metrics?.completeness || 0,
      icon: 'CheckCircle',
      color: 'text-success'
    },
    {
      label: 'Accuracy',
      value: metrics?.accuracy || 0,
      icon: 'Target',
      color: 'text-primary'
    },
    {
      label: 'Verification',
      value: metrics?.verification || 0,
      icon: 'Shield',
      color: 'text-trust'
    },
    {
      label: 'Timeliness',
      value: metrics?.timeliness || 0,
      icon: 'Clock',
      color: 'text-warning'
    }
  ];

  const overallScore = qualityIndicators?.reduce((sum, indicator) => sum + indicator?.value, 0) / qualityIndicators?.length;

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base font-semibold text-foreground">Data Quality</h3>
        <div className="flex items-center space-x-2">
          <div className={`text-lg font-bold ${
            overallScore >= 80 ? 'text-success' :
            overallScore >= 60 ? 'text-warning': 'text-error'
          }`}>
            {Math.round(overallScore)}%
          </div>
          <Icon 
            name={overallScore >= 80 ? 'TrendingUp' : overallScore >= 60 ? 'Minus' : 'TrendingDown'} 
            size={16} 
            className={overallScore >= 80 ? 'text-success' : overallScore >= 60 ? 'text-warning' : 'text-error'}
          />
        </div>
      </div>
      <div className="space-y-3">
        {qualityIndicators?.map((indicator) => (
          <div key={indicator?.label} className="space-y-1">
            <div className="flex items-center justify-between text-sm">
              <div className="flex items-center space-x-2">
                <Icon name={indicator?.icon} size={14} className={indicator?.color} />
                <span className="text-muted-foreground">{indicator?.label}</span>
              </div>
              <span className="font-medium text-foreground">{indicator?.value}%</span>
            </div>
            <div className="w-full bg-muted rounded-full h-2">
              <div 
                className={`h-2 rounded-full transition-all duration-300 ${
                  indicator?.value >= 80 ? 'bg-success' :
                  indicator?.value >= 60 ? 'bg-warning': 'bg-error'
                }`}
                style={{ width: `${indicator?.value}%` }}
              ></div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-3 border-t border-border">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">This Week</span>
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-1">
              <Icon name="FileText" size={14} className="text-primary" />
              <span className="text-foreground">{metrics?.submissionsThisWeek || 0} submissions</span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="Award" size={14} className="text-success" />
              <span className="text-foreground">{metrics?.averageScore || 0}% avg</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataQualityMetrics;  